import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountCreator  {
    _originalTypeClassName = "zERP.BO.AccountCreator";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountCreator.translate = translateService;
}
this.AccountCreatorKey = null;
this._key = this.AccountCreatorKey = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountCreatorKey:any;
get AccountCreatorKey(): any {
    return this._AccountCreatorKey;
  }
set AccountCreatorKey(value: any) {
    this._AccountCreatorKey = value;
    this._key = value;
  }

static RemoveRelatedAccounts(vObject: any): any{}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountCreatorKey == null || $this.AccountCreatorKey == 0;
            }


}